export const packageList = [
  {
    name: 'hr',
    activeRule: ['hr'],
    // preload: true
  },
  {
    name: 'legal',
    activeRule: ['lms'],
  },
  {
    name: 'flow',
    activeRule: ['oa'],
    preload: true
  },
  {
    name: 'kts',
    activeRule: ['kts'],
  },
  {
    name: 'tic',
    activeRule: ['tic'],
  },
]

export const remoteModuleConfig = {
  dev: ['hr', 'legal', 'flow', 'kts', 'tic'],
  stg: ['hr', 'legal', 'flow', 'kts', 'tic'],
  uat: ['hr', 'legal', 'flow', 'kts', 'tic'],
  prd: ['hr', 'legal', 'flow', 'kts', 'tic'],
}



// WEBPACK FOOTER //
// ./src/layout/router/remote/package-list/hr/index.js